module.exports = __webpack_public_path__ + "static/media/iconsmind.916e1950.eot";